import {alt} from 'epic-react-common';
import Immutable from 'seamless-immutable';
import {datasource} from 'alt-utils/lib/decorators';
import InviteActions from '../actions/InviteActions';
import InviteSource from '../sources/InviteSource';
import {seamlessImmutable} from 'epic-alt-utils';
import {localizedMessage} from '../components/message/Message';

@datasource(InviteSource)
@seamlessImmutable
class InviteStore {
  constructor() {
    this.on('error', (error) => {
      console.error(error);
    });
    this.state = Immutable({
      currentStage: 'INVITE',
      nextStage: '',
      currentInvites: 0,
      loading: false,
      errorMsg: '',
      prevPath: '',
    });
    this.bindActions(InviteActions);
  }

  onGetCurrentInvites(isLoggedIn) {
    if (isLoggedIn) {
      this.setState(this.state.merge({loading: true}));
      this.getInstance().getCurrentInvites();
    } else {
      this.setState(this.state.merge({currentStage: 'LOGIN'}));
    }
  }

  onGetCurrentInvitesSuccess(response) {
    if (response.status === 200 && !response.data.errorCode) {
      this.setState(
        this.state.merge({
          currentInvites: response.data.invites,
          loading: false,
        })
      );
    } else {
      let newState = this.state.merge({
        loading: false,
      });
      // Redirect to LOGIN Page if errorCode respondes account not logged in
      // this is unlikely as we check login status before geting invites
      if (response.data.errorCode === 'epic.code.invite.error.account_not_logged_in') {
        newState = newState.merge({currentStage: 'LOGIN'});
      }
      this.setState(newState);
    }
  }

  onGetCurrentInvitesFailure(error) {
    this.setState(
      this.state.merge({
        errorMsg: localizedMessage('epic.code.invite.failure.msg'),
        loading: false,
      })
    );
  }

  onSendInvite(inviteOptions) {
    const {isLoggedIn, email} = inviteOptions;
    if (isLoggedIn) {
      this.setState(this.state.set('loading', true));
      this.getInstance().sendInvite(email);
    } else {
      this.setState(
        this.state.merge({
          currentStage: 'LOGIN',
          loading: false,
        })
      );
    }
  }

  onSendInviteSuccess(response) {
    const errorMsg = localizedMessage('epic.code.invite.failure.msg');
    if (response.status === 200 && response.data.success === true) {
      this.setState(
        this.state.merge({
          currentInvites: response.data.invites,
          currentStage: 'SUCCESS',
          loading: false,
        })
      );
    } else if (!response.data.success) {
      // errorCode handling
      this.handleError(response.data.errorCode);
      this.setState(
        this.state.merge({
          loading: false,
        })
      );
    } else {
      this.setState(
        this.state.merge({
          errorMsg,
          loading: false,
        })
      );
    }
  }

  onSendInviteFailure(error) {
    const errorMsg =
      error.response && error.response.data && error.response.data.errorMessage
        ? error.response.data.errorMessage
        : localizedMessage('epic.code.invite.failure.msg');
    this.setState(
      this.state.merge({
        errorMsg,
        loading: false,
      })
    );
  }

  reset() {
    this.setState(
      this.state.merge({
        currentStage: 'INVITE',
        errorMsg: '',
        loading: false,
      })
    );
  }

  getPrevPath(path) {
    if (!path) return; // stop if no argument
    if (path !== '/fortnite/invite') {
      this.setState(
        this.state.merge({
          prevPath: path,
        })
      );
    }
  }

  handleError(error) {
    console.log('HANDLE ERROR');
    if (error.recipientEmail) {
      console.log('HANDLE ERROR: email error');
      switch (error.recipientEmail.errorCode) {
        case 'errors.com.epicgames.web.entitlement.already_entitled':
          this.setState(
            this.state.merge({
              errorMsg: localizedMessage('epic.code.invite.error.is_entitled'),
            })
          );
          break;
        case 'errors.com.epicgames.web.entitlement.no_invites_left':
          this.setState(
            this.state.merge({
              errorMsg: localizedMessage('epic.code.invite.error.no_invites'),
            })
          );
          break;
        case 'errors.com.epicgames.web.email.invalid_email':
          this.setState(
            this.state.merge({
              errorMsg: localizedMessage('epic.code.invite.error.invalid_email'),
            })
          );
          break;
        case 'errors.com.epicgames.web.email.sending_failed':
          this.setState(
            this.state.merge({
              errorMsg: localizedMessage('epic.code.invite.error.sending_failed'),
            })
          );
          break;
        default:
          this.setState(
            this.state.merge({
              errorMsg: localizedMessage('epic.code.invite.error.sending_failed'),
            })
          );
      }
    } else if (error === 'errors.com.epicgames.common.account_not_logged_in') {
      this.setState(
        this.state.merge({
          currentStage: 'LOGIN',
        })
      );
    } else {
      console.log("An error exception that hasn't been handled properly");
    }
  }
}

export default alt.createStore(InviteStore, 'InviteStore');
